/* eslint-disable */
<template>
  <div style="max-height:300px; overflow:auto; background:#fafafa;">
    <v-card elevation="0" ref="discussion">
      <v-card width="100%" elevation="0">
        <div class="center-discussion" v-if="!showDiscussion">
          <v-btn class="branded-background text-white show-discussion" @click="loadDiscussion()" aria-label="Show discussion button. Press enter to load discussion data.">Show Discussion</v-btn>
        </div>
        <div class="center" v-if="showDiscussion" style="background:white;">
          <div class="refresh-discussion">
            <v-btn name="refreshDiscussion" icon @click="getDiscussion()" class="refresh-discussion-id" aria-label="Refresh discussion button. Press enter to refresh discussion data.">
              <Tooltip top>
                <v-icon color="white" >refresh</v-icon>
                <template v-slot:text>
                  Refresh Discussion
                </template>
              </Tooltip>
            </v-btn>
          </div>
          <v-layout row style="width:100%">
            <v-flex class="question-format" id="discussion-monitor-wrap" xs12 v-dompurify-html="interactionText"></v-flex>
          </v-layout>
          <div class="discussion-comments-wrapper pa-3 full-width">
            <v-list style="width:100%;" v-if="loaded && discussionAttempts.length > 0">
              <template v-for="comment in discussionAttempts">
                <div v-if="comment.userId == studentId">
                  <v-container :key="comment.id" pa-2 grid-list-md class="discussion-comment" :id="'comment-' + comment.id" >
                    <v-layout row>
                      <v-flex xs2 class="left" align-self-start>
                        <v-layout column align-content-start fill-height>
                          <avatar v-if="!comment.deleted" :size="36" :username="comment.name"></avatar>
                          <avatar v-if="comment.deleted"  :size="36"  color="white"  backgroundColor="black" initials="-" :username="comment.initials"></avatar>
                          <a class="caption grey--text comment-timestamp">{{formatDuration(comment.displayTime)}}</a>
                        </v-layout>
                      </v-flex>
                      <v-flex xs10 class="right">
                        <h4 class="comment-name" style="color: rgba(0,0,0,.87);">
                          {{comment.name}}
                          <span class="caption grey--text">- {{fromNow(comment.created)}}</span>
                        </h4>
                        <div class="comment-content" v-dompurify-html="comment.text" style="color: rgba(0,0,0,.87);"></div>
                        <div class="comment-replies">
                          <template  v-for="reply in comment.replies">
                            <div v-if="reply.userId == studentId">
                              <v-container :key="reply.id" pa-2 grid-list-md class="discussion-comment" :id="'comment-' + reply.id">
                                <v-layout row>
                                  <v-flex xs2 class="left">
                                    <v-layout column align-center>
                                      <avatar v-if="!reply.deleted" :size="36" :username="reply.name"></avatar>
                                      <avatar v-if="reply.deleted"  :size="36"  color="white"  backgroundColor="black" initials="-" :username="reply.initials"></avatar>
                                      <a class="caption grey--text comment-timestamp">{{formatDuration(reply.displayTime)}}</a>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex xs10 class="right">
                                    <h4 class="comment-name" style="color: rgba(0,0,0,.87);">
                                      {{reply.name}}
                                      <span class="caption grey--text">- {{fromNow(reply.created)}}</span>
                                    </h4>
                                    <div class="comment-content" v-dompurify-html="reply.text" style="color: rgba(0,0,0,.87);"></div>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </div>
                          </template> <!-- end reply comment wrapper -->
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </div>
                <div v-if="comment.userId != studentId">
                  <template v-for="reply in comment.replies">
                    <div v-if="reply.userId == studentId">
                      <v-container :key="comment.id" pa-2 grid-list-md class="discussion-comment" :id="'comment-' + comment.id" >
                        <v-layout row>
                          <v-flex xs2 class="left" align-self-start>
                            <v-layout column align-content-start fill-height>
                              <avatar v-if="!comment.deleted" :size="36" :username="comment.name"></avatar>
                              <avatar v-if="comment.deleted"  :size="36"  color="white"  backgroundColor="black" initials="-" :username="comment.initials"></avatar>
                              <a class="caption grey--text comment-timestamp">{{formatDuration(comment.displayTime)}}</a>
                            </v-layout>
                          </v-flex>
                          <v-flex xs10 class="right">
                            <h4 class="comment-name"style="color: rgba(0,0,0,.87);">
                              {{comment.name}}
                              <span class="caption grey--text">- {{fromNow(comment.created)}}</span>
                            </h4>
                            <div class="comment-content" v-dompurify-html="comment.text" style="color: rgba(0,0,0,.87);"></div>
                            <div class="comment-replies">
                              <v-container :key="reply.id" pa-2 grid-list-md class="discussion-comment" :id="'comment-' + reply.id">
                                <v-layout row>
                                  <v-flex xs2 class="left">
                                    <v-layout column align-center>
                                      <avatar v-if="!reply.deleted" :size="36" :username="reply.name"></avatar>
                                      <avatar v-if="reply.deleted"  :size="36"  color="white"  backgroundColor="black" initials="-" :username="reply.initials"></avatar>
                                      <a class="caption grey--text comment-timestamp">{{formatDuration(reply.displayTime)}}</a>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex xs10 class="right">
                                    <h4 class="comment-name" style="color: rgba(0,0,0,.87);">
                                      {{reply.name}}
                                      <span class="caption grey--text">- {{fromNow(reply.created)}}</span>
                                    </h4>
                                    <div class="comment-content" v-dompurify-html="reply.text" style="color: rgba(0,0,0,.87);"></div>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </div>
                  </template> <!-- end reply comment wrapper -->
                </div>
              </template> <!-- end root comment wrapper -->
            </v-list>
            <v-list style="overflow:auto; height: 250px; width:100%;" v-if="loaded && discussionAttempts.length === 0">
              <v-list-tile>
                <v-list-tile-title class="center" style="padding-top: 40px;">
                  No Discussion Comments
                </v-list-tile-title>
              </v-list-tile>
            </v-list>
            <div class="loading-screen" v-if="!loaded">
              <v-progress-circular indeterminate v-bind:size="50" class='branding-active-text'></v-progress-circular>
            </div>
          </div> <!-- end discussion wrapper -->
        </div>
      </v-card>
    </v-card>
  </div>
</template>

<script>
/* global dataLayer */
import Color from 'color';
import moment from 'moment';
import Avatar from 'vue-avatar';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'discussion',
  props: [
    'interactionId',
    'interactionText',
    'sectionId',
    'studentId',
  ],
  components: {
    Avatar,
  },
  data() {
    return {
      discussionAttempts: [],
      loaded: false,
      showDiscussion: false,
    };
  },
  computed:{
    ...mapGetters([
      'instructorData',
      'learnerData',
      'simpleDash'
    ]),
    ...mapGetters('instructors', [
      'activeViewInstructor',
    ]),
    ...mapGetters('learners', [
      'activeViewLearners'
    ]),
  },
  methods:{
    ...mapActions([
    ]),
    loadDiscussion() {
      //toggle discussion view on and call for discussion data
      this.showDiscussion = true;
      this.getDiscussion();
    },
    getDiscussion() {
      // refresh discussion data
      let token = '';
      if (['Interactions', 'Learner-Made-Bulbs-Monitor', 'Single-Interaction' , 'Student-Interaction', 'Learner-Made-Bulb-Monitor', 'Peer-Review'].includes(this.activeViewInstructor) || this.simpleDash || ['LMB-Monitor'].includes(this.activeViewLearners)) {
        token = this.instructorData.token;
      } else {
        token = this.learnerData.token;
      }
      this.$store.dispatch('instructors/getDiscussionData', {
        interactionId: this.interactionId,
        sectionId: this.sectionId,
        token
      })
      .then(da => {
        this.loaded = true;
        this.discussionAttempts = da.data
      })
      .catch(err => {
        this.loaded = false;
        console.log(err, 'error getting discussionAttempts')
      })
    },

    //helper functions to format data
    fromNow(time) {
       //helper for discussions to format time
      return moment(time).fromNow();
    },
    formatDuration(time) {
      //helper for discussions to format time
      const sec_num = parseInt(time, 10); // don't forget the second param
      let hours   = Math.floor(sec_num / 3600);
      let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
      let seconds = sec_num - (hours * 3600) - (minutes * 60);
      if (!hours) hours = 0;
      if (!minutes) minutes = 0;
      if (!seconds) seconds = 0;
      return (hours >= 1 ? hours+":" : "") + (minutes < 10 ? "0"+minutes : minutes) + ":" + (seconds < 10 ? "0"+seconds : seconds);
    },

  },
  watch: { },
  created() { },
  mounted() { },
  beforeDestroy() { }
};
</script>

<style scoped>
  #discussion-monitor-wrap >>> ol {
    padding-left: 24px !important;
  }
  #discussion-monitor-wrap >>> li, p {
    font-size: 15px !important;
  }
  #discussion-monitor-wrap >>> li {
    color: rgba(0,0,0,.87);
    line-height: 1.5 !important;
  }
  #discussion-monitor-wrap >>> strong {
    color:rgba(0,0,0,.87);
  }
  #discussion-monitor-wrap >>> em {
    color:rgba(0,0,0,.87);
  }
  #discussion-monitor-wrap >>> p {
    margin:0 !important;
    line-height: 1.5 !important;
  }
</style>
